import { useContext, useMemo } from "react";

import { CanvasThemesProviderContext } from "@/components/canvas-themes-provider/canvas-themes-provider-component";
import useProperties from "@/hooks/use-properties";

export default function useTheme() {
  const { themes } = useContext(CanvasThemesProviderContext);
  const { theme: selectedTheme, updateTheme } = useProperties();

  const currentTheme = useMemo(
    () => themes.find((theme) => selectedTheme.kind === theme.kind),
    [themes, selectedTheme]
  );

  /**
   * @deprecated
   * Use updateTheme instead
   */
  const replaceWithTheme = updateTheme;

  return { themes, updateTheme, replaceWithTheme, currentTheme };
}
